import React, { useState } from "react";
import ModalBasic from "../../../pages/component/ModalBasic";
import Table from "../../table/Table";
import ActionEditButton from "../../UIComponent/ActionTableComponent/ActionEditButton";
import TextInput from "../../UIComponent/TextInput";
import { eventPropTypes } from "@tinymce/tinymce-react/lib/cjs/main/ts/components/EditorPropTypes";



// const onEdit = (value, index) => {
//     let editDetails = [...this.state.getAuthorityLimitList];
//     this.state.editId = editDetails[index].authorityLimitId;
//     this.getAuthorityLimitById(this.state.editId);
// }
const SelectExcoMemberModal = (props) => {
    const [dropdownId, setDropdownId] = useState(0);
    const [positionId, setPositionId] = useState(1);

    // const setPagination = (newPagination) => {
    //     this.setState({ pagination: newPagination });
    // }

    // const actions = (element) => {
    //     return (element !== "pagesDetailsId") ? null
    //         : <ActionContainer>
    //             <ActionEditButton
    //                 text="Edit"
    //             />
    //         </ActionContainer>
    // }
    // useEffect(() => {
    //     if (props.selectExcoMemberChecked === true || props.selectExcoMemberChecked === "true") {
    //         selectedRows = [];
    //     }
    // },[props]);
    const [selectedRows, setSelectedRows] = useState([]);

    // var selectedRows = new Array();
    const handleCheckbox = (event, row, index) => {
        let tempArr = [...selectedRows];
        if (event.target.checked === true) {
            tempArr.push(row);
            setSelectedRows(tempArr);
            props.setHandleCheckboxForRemoveExco(row, index, event.target.checked);
        } else {
            // var index = tempArr.indexOf(row);
            if (index > -1) {
                tempArr.splice(index, 1);
                setSelectedRows(tempArr);
                props.setHandleCheckboxForRemoveExco(row, index, event.target.checked);
            }
        }
    }
    const onEdit = (value, index, e) => {
        let editDetails = [...props.rows];
        let editId = editDetails[index].excoMemberId;
        props.getExcoMemberById(editId, e, true);
    }

    const actions = (element, index, value) => {
        if (element === "excoMemberId") {
            return (
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap pointer">
                    {props.editOderingId === true &&
                        positionId === props.rows[index].orderingId &&
                        dropdownId === props.rows[index].excoMemberId ? (
                        <div className="flex items-center justify-center edit-field">
                            <button
                                className="action-btn mr-4 flex items-center"
                                aria-controls="add-edit-modal"
                                onClick={() => {
                                    props.editExcoMember(
                                        props.rows[index].excoMemberId
                                    );
                                }}
                            >
                                <p className="ml-2 tool-tip-txt text-[#c00000] underline cursor-pointer">
                                    Save
                                </p>
                            </button>
                            <button
                                className="action-btn mr-4 flex items-center pr-5 min-w-[50px]"
                                aria-controls="add-edit-modal"
                                onClick={() => {
                                    // Call a function to cancel editing (if needed)
                                    // reset the positionId and dropdownId state
                                    setDropdownId(0);
                                    setPositionId(1);
                                }}
                            >
                                <img
                                    src="/cancel-icon.png"
                                    className="w-[22px] mx-auto my-0"
                                    alt=""
                                />
                            </button>
                        </div>
                    ) : (
                        <div className="flex items-center relative">
                            <ActionEditButton
                                value={value}
                                id={index}
                                index={index}
                                onActionClick={(e) => onEdit(value, index, e)} // Use the onEdit handler
                                text="Edit"
                            />
                        </div>
                    )}
                </td>
            );
        }

        if (element === "orderingId") {
            const onClickEdit = (row) => {
                setDropdownId(row.excoMemberId); // Update dropdownId
                setPositionId(row.orderingId); // Update positionId
            };

            return (
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap pointer">
                    <div className="flex items-center relative">
                        {props.editOderingId === true &&
                            positionId === props.rows[index].orderingId &&
                            dropdownId === props.rows[index].excoMemberId ? (
                            <div key={index} className="flex flex-col relative">
                                <div className="edit-field input-height-set center-text">
                                    <TextInput
                                        placeholder=""
                                        type="number"
                                        name="orderingId"
                                        max={props.length - 1}
                                        value={
                                            props.excoMemberData.orderingId <= 0
                                                ? 1
                                                : props.excoMemberData.orderingId
                                        }
                                        handleChange={(event) =>
                                            props.handleChangeForOrderingId(event)
                                        }
                                        identity="DropdownorderingId"
                                        min={1}
                                    />
                                </div>
                                <div className="absolute bottom-[-22px]">
                                    {/* Validation for orderingId */}
                                </div>
                            </div>
                        ) : (
                            <div className="flex items-center gap-3">
                                <div className="current-text text-center">
                                    {props.rows[index].orderingId}
                                </div>
                                <button
                                    className="action-btn"
                                    aria-controls="add-edit-modal"
                                    onClick={(e) => {
                                        onClickEdit(props.rows[index]);
                                        props.getExcoMemberById(props.rows[index].excoMemberId, false);
                                    }}
                                >
                                    <p className="ml-2 tool-tip-txt underline text-[#757575]">
                                        <svg
                                            className="menu-svg"
                                            width="24"
                                            height="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 88 88"
                                        >
                                            <g transform="translate(0.000000,88.000000) scale(0.100000,-0.100000)">
                                                <path
                                                    d="M645 871 c-11 -5 -142 -132 -290 -282 l-271 -274 -41 -145 c-23 -80 -38 -149 -34 -153 5 -4 74 11 153 34 l146 41 282 283 c332 333 318 302 197 422 -72 72 -105 89 -142 74z m123 -105 c40 -41 72 -79 72 -85 0 -16 -90 -111 -104 -111 -6 0 -49 38 -96 85 l-84 85 49 50 c28 29 58 50 70 50 14 0 49 -28 93 -74z m-198 -91 l34 -36 -191 -191 -191 -191 -16 32 c-10 19 -24 31 -36 31 -11 0 -20 3 -20 7 0 9 372 383 380 383 4 0 21 -16 40 -35z m103 -103 l37 -38 -194 -187 c-107 -103 -197 -187 -200 -187 -3 0 -6 8 -6 19 0 11 -12 23 -30 31 -16 7 -30 15 -30 19 0 7 373 381 380 381 3 0 23 -17 43 -38z m-488 -320 c12 -21 36 -45 58 -57 32 -17 37 -24 35 -49 -3 -25 -9 -31 -48 -42 l-45 -14 -51 53 -51 52 14 48 c12 41 18 47 41 47 21 0 32 -8 47 -38z m-51 -171 c-3 -3 -23 -11 -45 -17 -44 -13 -45 -12 -28 50 l11 38 34 -33 c18 -18 31 -35 28 -38z"
                                                    fill="#6e6e6e"
                                                />
                                            </g>
                                        </svg>
                                    </p>
                                </button>
                            </div>
                        )}
                    </div>
                </td>
            );
        }
    };




    const select = (element, index, value) => {
        return (element !== "selectRow") ? null
            :
            <div className="p-4">
                <input
                    id="isRequireQuotation"
                    name="isRequireQuotation"
                    type="checkbox"
                    className="cursor-pointer h-6 w-6 text-[#313984] focus:ring-[#313984] rounded check-box-custom"
                    onChange={(event) => handleCheckbox(event, value, index)}
                    checked={props.rows[index].checkedValue}
                />

            </div>
    }
    return (
        <>
            <ModalBasic
                id="select-exco-member-modal"
                modalOpen={props.setSelectExcoMemberModal}
                setModalOpen={props.setOpenModal}
                title="Select Individual Record"
            >
                <div className="px-14 py-4">
                    {/* <label className="flex justify-end text-[#cb0000] text-lg underline">Select Existing Account</label> */}
                    <main className="pb-10">
                        <div className="w-full mx-auto">
                            <div className="relative">
                                <div>
                                    <div className=" mt-6">
                                        <Table columns={props.columns}
                                            pagination={props.pagination}
                                            rows={props.rows}
                                            sortingColumns={props.sortingColumns}
                                            isLoading={props.isLoading}
                                            totalResultes={props.totalResultes}
                                            totalCount={props.totalCount}
                                            setPagination={props.setPagination}
                                            // customScope={props.customScope}
                                            tableIdentity={props.tableIdentity}
                                            customScope={[
                                                {
                                                    column: 'excoMemberId',
                                                    renderTableData: actions.bind(this)
                                                },
                                                {
                                                    column: 'orderingId',
                                                    renderTableData: actions.bind(this)
                                                },
                                                {
                                                    column: 'selectRow',
                                                    renderTableData: select.bind(this),
                                                    valueColumnName: "excoMemberId"
                                                },
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    <div className="flex items-center justify-between px-6 py-6 pt-0">
                        <button
                            className="btn btn-gray text-lg text-white font-bold"
                            onClick={(event) => props.onClose(event)}
                        >
                            Cancel
                        </button>
                        {selectedRows.length > 0 ?
                            <button
                                className="btn btn-red text-lg text-white font-bold"
                                onClick={() => props.removeExcoMember(selectedRows)}
                            >
                                Remove
                            </button>
                            : null}
                    </div>
                </div >
            </ModalBasic>
        </>
    );
}
export default SelectExcoMemberModal;

// export default class SelectExcoMemberModal extends Component {
//     constructor(props) {
//         super(props)
//         this.chapterXCommitteeWorkgroupServices = new PagesManagementServices();
//         this.swalServices = new SwalServices();
//         this.state = {
//             pagination: {
//                 pageNo: 1,
//                 pageSize: 10,
//                 orderByColumn: "",
//                 orderFlag: 0,
//                 searchText: "",
//                 status: 0,
//                 filterByType: 0,
//                 filterByStatus: 0
//             },
//             totalResultes: "",
//             getXCommitteeWorkgroupList: [
//                 {
//                     email: "johnl@abctech.com",
//                     firstName: "John",
//                     lastName: "Low",
//                     comapany: "ABC Technologies",
//                     excoPosition: "Vice Chair",
//                     joinDate: "20 Jan 2021",
//                 },
//                 {
//                     email: "johnl@abctech.com",
//                     firstName: "John",
//                     lastName: "Low",
//                     comapany: "ABC Technologies",
//                     excoPosition: "Vice Chair",
//                     joinDate: "20 Jan 2021",
//                 },
//             ],
//             isLoading: false,
//             redirect: null,
//         }
//     }

//     setPagination = (newPagination) => {
//         this.setState({ pagination: newPagination });
//     }

//     onEdit = (value, index) => {
//         let editResourcePages = [...this.state.getXCommitteeWorkgroupList];
//     }

//     actions = (element, index, value) => {
//         return (element !== "pagesDetailsId") ? null
//             : <ActionContainer>
//                 <ActionEditButton
//                     text="Edit"
//                 />
//             </ActionContainer>
//     }

//     select = (element) => {
//         return (element !== "selectRow") ? null
//             :
//             <div className="p-4">
//                 <input type="checkbox" className="h-6 w-6 " />
//             </div>
//     }
//     render() {
//         if (this.state.redirect != null) {
//             return <Navigate to={this.state.redirect} />;
//         }
//         return (
//             <ModalBasic
//                 id="select-exco-member-modal"
//                 modalOpen={this.props.setSelectExcoMemberModal}
//                 setModalOpen={this.props.setOpenModal}
//                 title="Select EXCO Member"
//             >
//                 <div className="px-14 py-4">
//                     <main className="pb-10">
//                         <div className="w-full mx-auto">
//                             <div className="relative">
//                                 <div>
//                                     <div className=" mt-6">
//                                         <Table columns={[{ name: 'selectRow', title: '' }, { name: 'email', title: 'Email' }, { name: 'firstName', title: 'First Name' }, { name: 'lastName', title: 'Last Name' }, { name: 'comapany', title: 'Company' }, { name: 'excoPosition', title: 'EXCO Position' }, { name: 'joinDate', title: 'Join Date' }, { name: 'pagesDetailsId', title: 'Action' }]}
//                                             pagination={this.state.pagination}
//                                             rows={this.state.getXCommitteeWorkgroupList}
//                                             sortingColumns={[""]}
//                                             // isLoading={this.state.isLoading}
//                                             // totalResultes={this.state.totalResultes}
//                                             // totalCount={this.state.totalResultes}
//                                             setPagination={this.setPagination.bind(this)}
//                                             customScope={[
//                                                 {
//                                                     column: 'pagesDetailsId',
//                                                     renderTableData: this.actions.bind(this)
//                                                 },
//                                                 {
//                                                     column: 'selectRow',
//                                                     renderTableData: this.select.bind(this)
//                                                 },
//                                             ]}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </main>

//                     <div className="grid grid-cols-6 gap-4 px-6 py-16">
//                         <button
//                             className="col-start-1 col-end-3  w-32 px-7 py-2 bg-zinc-500 text-lg text-white font-bold"
//                             onClick={(event) => this.props.onClose(event)}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             className="col-end-7 col-span-2 w-full py-2 btn-sm btn-red text-lg text-white font-bold"
//                         >
//                             Remove EXCO Member
//                         </button>
//                     </div>
//                 </div >
//             </ModalBasic>
//         );
//     }
// }